import axios from '../utils/axios'

/**
 * 检测登陆态
 * 返回 isLogin
 */
export function checkLogin (data = {}) {
  return axios({
    url: '/WechatService/CheckLogin',
    method: 'post',
    data: data
  })
}

/**
 * 登陆固定接口
 * 传递 code
 * 返回 登录态 + session
 */
export function loginMode (code) {
  return axios({
    url: '/WechatService/Login',
    method: 'post',
    data: {
      code: code
    }
  })
}

// 获取是否完成订单以及是否关注公众号（用于浏览器缓存token时，额外调用获取的接口）
export function SAppShortInfo (params) {
  return axios({
    url: '/Member/SApp/SAppShortInfo',
    method: 'get',
    params: params
  })
}

/**
 * 注册接口
 * params:
 *  TelCode 验证码
 *  Tel 手机号码
 *  Recommend 推荐人
 *  tokenid 临时的回话认证ID
 * res:
 *  tokenid
 *  isLogin
 *  info:{}
 */
export function UserRegister (data = {}) {
  return axios({
    url: '/WechatService/Register',
    method: 'post',
    data: data
  })
}

// 授权弹窗获取是否展现苹果授权登陆入口
export function AuthCfg (data = {}) {
  return axios({
    url: '/WechatService/AuthCfg',
    method: 'post',
    data: data
  })
}

/**
 * 获取验证码
 * Tel: XXX
 */
export function GetTelCode (data = {}) {
  return axios({
    url: '/Login/GetTelCode',
    method: 'post',
    data: data
  })
}
